import ApiCampaignsClient from './ApiCampaignsClient';

class CampaignsManagerAPI extends ApiCampaignsClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }
}

export default new CampaignsManagerAPI();
